import request from '@/utils/request'


//课程切换
//GET /major/majormainDO/
export function majormainDO(data) {
	return request({
		url: '/major/majormainDO/',
		method: 'get',
		params: data
	})
}

// GET /major/majormainDO/list
export function listMajorByPid(params) {
	return request.get(`/major/majormainDO/list`, { params })
}
